import React, { useEffect } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog,
  Box,
  createFilterOptions,
  TextField,
  MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useGenTasksFormEditHook from '../CustomHooks/useGenTasksEditHook';

import RepairAndMaintananceForm from './RepairAndmaintanance';
import GeneralTaskForm, { ALL_TASK_OPTIONS, GENERAL_TASKS } from './GeneralTaskForm';
import GenTaskDrivingForm from './GenTaskDrivingForm';
import useDocs from '../CustomHooks/useDocs';
import ExpenseClaimForm from './GenTaskExpenseClaim';
import useGetUser from 'routes/Auth/useGetUser';

const EditGenTaskFormDialog = ({
  open,
  setOpen,
  selectedGenTask,
  handleSuccessfulSubmit,
  vehicalList,
  trailerList,
  checkListOpt,
  typeOfRepairoption,
  dataId,
}) => {
  const {
    handleClose,
    submitEditedData,
    drivingData,
    setDrivingData,
    setNewUploadedFiles,
    EditVehicalCheckListData,
    vehicalCheckList,
    generalFormData,
    repairAndmaintananceData,
    setGeneralFormData,
    setRepairAndmaintananceData,
    expenseClaimData,
    setExpenseClaimData,
    handleTaskChange,
  } = useGenTasksFormEditHook(selectedGenTask, open, setOpen, handleSuccessfulSubmit);

  const { user } = useGetUser();

  const currentTask =
    drivingData?.task ||
    generalFormData?.task ||
    repairAndmaintananceData?.task ||
    expenseClaimData?.task ||
    selectedGenTask?.task;

  const { files, isLoading, handleFileChange, handleDeleteFiles, viewFile } = useDocs(selectedGenTask?.id);

  const TASK_OPTIONS = user?.roleId === 1 ? ALL_TASK_OPTIONS : ALL_TASK_OPTIONS.filter(item => item !== 'Clock In');

  return (
    <Dialog
      sx={{
        fontFamily: 'Normal !important',
        '& .MuiDialog-paper': {
          overflow: 'hidden',
        },
      }}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Edit {currentTask} - ID : {selectedGenTask?.id}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}>
        <CloseIcon />
      </IconButton>
      <form
        onSubmit={e => {
          e.preventDefault();
          submitEditedData();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}>
        <DialogContent
          dividers
          sx={{
            height: '75vh', // limit modal content height to 60% viewport height
            overflow: 'auto',
            paddingBottom: '0.5rem',
          }}>
          <TextField
            select
            required
            label="Task Name"
            value={currentTask}
            onChange={e => handleTaskChange(e.target.value)}
            fullWidth
            size="small">
            {TASK_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </TextField>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '100%', paddingBlock: '0.5rem' }}>
            {currentTask == 'Vehicle Check List' && (
              <GenTaskDrivingForm
                data={drivingData}
                setData={setDrivingData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                checklistOptions={checkListOpt}
                vehicalOption={vehicalList}
                trailerOptions={trailerList}
                checkListData={vehicalCheckList}
                handleCheckListEdit={EditVehicalCheckListData}
              />
            )}

            {GENERAL_TASKS.includes(currentTask) && <GeneralTaskForm data={generalFormData} setData={setGeneralFormData} />}

            {currentTask == 'Expense Claim' && (
              <ExpenseClaimForm
                data={expenseClaimData}
                setData={setExpenseClaimData}
                files={files}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}

            {currentTask == 'Repairs & Maintainance' && (
              <RepairAndMaintananceForm
                data={repairAndmaintananceData}
                setData={setRepairAndmaintananceData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                checklistOptions={checkListOpt}
                vehicalOption={vehicalList}
                trailerOptions={trailerList}
                checkListData={vehicalCheckList}
                handleCheckListEdit={EditVehicalCheckListData}
                onTaskChange={handleTaskChange}
                typeOfRepairoption={typeOfRepairoption}
                selectedGenTask={selectedGenTask.id}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
            {currentTask == 'External Repairs' && (
              <RepairAndMaintananceForm
                data={repairAndmaintananceData}
                setData={setRepairAndmaintananceData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                checklistOptions={checkListOpt}
                vehicalOption={vehicalList}
                trailerOptions={trailerList}
                checkListData={vehicalCheckList}
                handleCheckListEdit={EditVehicalCheckListData}
                typeOfRepairoption={typeOfRepairoption}
                selectedGenTask={selectedGenTask.id}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditGenTaskFormDialog;
